'use client';

import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { listSettings, updateSetting } from '@nomiss/services';

export const adminSettingsQueryKeys = {
  all: ['admin', 'settings'] as const,
  list: () => [...adminSettingsQueryKeys.all, 'list'] as const,
};

export function useAdminSettings(options?: { enabled?: boolean }) {
  const adminSettingsQuery = useQuery({
    queryKey: adminSettingsQueryKeys.list(),
    queryFn: () => listSettings(),
    enabled: options?.enabled ?? true,
  });

  return { adminSettingsQuery };
}

export function useUpdateSetting() {
  const queryClient = useQueryClient();

  const updateSettingMutation = useMutation({
    mutationFn: ({ key, value }: { key: string; value: string }) =>
      updateSetting(key, value),
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: adminSettingsQueryKeys.list(),
      });
    },
  });

  return { updateSettingMutation };
}
